var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyePasswordHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.79 12.912L9.176 11.297C8.55184 11.5202 7.87715 11.5615 7.23042 11.4162C6.58369 11.2709 5.99153 10.9449 5.52282 10.4762C5.05411 10.0075 4.72814 9.41531 4.58283 8.76858C4.43752 8.12185 4.47885 7.44716 4.702 6.823L2.642 4.763C0.938 6.278 0 8 0 8C0 8 3 13.5 8 13.5C8.96049 13.4975 9.91019 13.2973 10.79 12.912ZM5.21 3.088C6.08981 2.70266 7.03951 2.50251 8 2.5C13 2.5 16 8 16 8C16 8 15.061 9.721 13.359 11.238L11.297 9.176C11.5202 8.55184 11.5615 7.87715 11.4162 7.23042C11.2709 6.58369 10.9449 5.99153 10.4762 5.52282C10.0075 5.05411 9.41531 4.72814 8.76858 4.58283C8.12185 4.43752 7.44716 4.47885 6.823 4.702L5.21 3.088Z",
    fill: "#003738"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.52548 7.64648C5.47048 8.03079 5.50573 8.42263 5.62845 8.79096C5.75117 9.15928 5.95798 9.49396 6.2325 9.76847C6.50701 10.043 6.84169 10.2498 7.21001 10.3725C7.57833 10.4952 7.97017 10.5305 8.35448 10.4755L5.52548 7.64648ZM10.4755 8.35448L7.64648 5.52448C8.03079 5.46948 8.42263 5.50473 8.79096 5.62745C9.15928 5.75017 9.49396 5.95698 9.76847 6.2315C10.043 6.50601 10.2498 6.84069 10.3725 7.20901C10.4952 7.57733 10.5305 7.96917 10.4755 8.35348V8.35448ZM13.6465 14.3545L1.64648 2.35448L2.35448 1.64648L14.3545 13.6465L13.6465 14.3545Z",
    fill: "#003738"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyePasswordHide);
export default __webpack_public_path__ + "static/media/eyePasswordHide.f4f2a57a3c85a4f77573ad22ee174f61.svg";
export { ForwardRef as ReactComponent };